var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _g3, _g4, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g5, _g6, _g7, _path15, _path16, _path17, _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtMagnifyingGlass = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 95,
    viewBox: "0 0 107 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 5.316 6.733 3.993 3.91-4.028C2.58.499 6.932 3.08 1.736 0L0 5.316z",
    id: "c0ouwiug8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.573 12.88c-1.649 5.228-7.266 8.142-12.544 6.509-5.278-1.633-8.22-7.198-6.57-12.426C2.106 1.734 7.723-1.18 13.001.453c5.278 1.634 8.22 7.199 6.571 12.427z",
    id: "7qano9hi7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.793 30.485c-8.097 3.654-17.65.116-21.34-7.906C-2.234 14.558 1.34 5.095 9.435 1.44c8.098-3.654 17.65-.115 21.34 7.906 3.689 8.021.114 17.484-7.98 21.139z",
    id: "cvhxa36u8e"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#89CFE5",
    fillRule: "nonzero",
    d: "M29.25 72.675 55.469.255 107 18.564l-26.22 72.42z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.407 5.791 47.551 14.72-23.215 69.525C26.182-2.12 28.733 7.647 29.407 5.791z",
    fill: "#D9F4FF",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(24.055 .029)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCF5FF",
    fillRule: "nonzero",
    d: "M24.055 78.605 47.216 5.168 99.473 21.34 76.31 94.778z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.127 14.675c-.574-1.013 1.546-.107-16.757-5.77l-6.559 20.788 21.125 6.54 5.54-17.567a14.234 14.234 0 0 1-3.352-3.991h.003z",
    fill: "#9CD9F2",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.772 11.657c-.193.322-.399.078 1.573 1.245l3.868-5.749-.024-2.043c.915-.402 3.202.93 3.278 1.944l-1.827.944-3.288 6.095c1.992 1.18 1.665 1.093 1.852.786l-1.491-.886L64.84 8.2c2.093-1.082 1.88-.947 1.897-1.041.184-1.184-2.798-2.952-3.765-2.232-.08.059-.058-.192-.031 2.149l-3.68 5.467-1.49-.885h.001z",
    fill: "#B59F69",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.73 11.608c3.1 1.836 4.065 2.409 6.734 3.992l3.909-4.028-8.905-5.28-1.737 5.316z",
    fill: "#2A292B",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.73 6.292)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0omiw2fl2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c0ouwiug8a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#0omiw2fl2b)",
    fill: "#444",
    fillRule: "nonzero",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.517 2.286a1.364 1.364 0 0 1 1.885.353l1.754 2.544a1.336 1.336 0 0 1-.356 1.868l-7.888 5.328a1.364 1.364 0 0 1-1.885-.353L3.276 9.48a1.336 1.336 0 0 1 .356-1.867l7.887-5.328-.002.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.945-1.001A1.364 1.364 0 0 1 9.83-.65l1.751 2.545a1.336 1.336 0 0 1-.356 1.867l-7.89 5.328A1.364 1.364 0 0 1 1.45 8.74L-.3 6.194a1.336 1.336 0 0 1 .356-1.867l7.887-5.328h.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18-1.037a1.364 1.364 0 0 1 1.885.353l1.752 2.544a1.336 1.336 0 0 1-.356 1.868L2.573 9.056a1.364 1.364 0 0 1-1.885-.353L-1.066 6.16A1.336 1.336 0 0 1-.71 4.29l7.888-5.328h.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.703-2.68a1.364 1.364 0 0 1 1.886.353L7.34.218a1.336 1.336 0 0 1-.356 1.867L-.903 7.413a1.364 1.364 0 0 1-1.885-.353l-1.754-2.546a1.336 1.336 0 0 1 .356-1.868l7.89-5.328v.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.643-1.79a1.364 1.364 0 0 1 1.885.353l1.754 2.545c.42.613.262 1.448-.357 1.867L.035 8.303a1.364 1.364 0 0 1-1.884-.353l-1.752-2.546a1.338 1.338 0 0 1 .356-1.868l7.888-5.328v.003z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.375 11.572c-10.255-6.08-9.094-5.193-8.434-5.503 9.57 5.673 8.312 4.727 8.434 5.503zM56.509 11.473c.16-.268-.177-.36 7.062 3.933.206.121.07.303.082.303-.16.265.177.36-7.063-3.933-.148-.088-.117-.303-.081-.303z",
    fill: "#0C0C0C",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.634 11.574c-.196.322-.4.078 1.574 1.245l3.869-5.749-.024-2.04c.958-.421 3.209.977 3.28 1.943l-1.827.944-3.288 6.095c1.99 1.181 1.665 1.091 1.852.786l-1.491-.883 3.125-5.794c2.096-1.084 1.883-.947 1.897-1.044.182-1.186-2.793-2.951-3.765-2.232-.08.06-.058-.194-.032 2.147l-3.68 5.468-1.49-.886z",
    fill: "#FFCB39",
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.655 27.617 2.12-6.72 2.034.63-2.12 6.72zM64.4 31.562l2.118-6.72 2.035.63-2.12 6.72zM54.224 28.41l3.255-10.32 2.035.629-3.255 10.32zM61.83 30.764l3.255-10.32 2.034.63-3.254 10.32zM56.78 29.203l2.635-8.352 2.034.63-2.634 8.351zM59.3 29.981l.893-2.833 2.034.63-.893 2.833z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    fillRule: "nonzero",
    d: "m51.756 29.242.513-1.626 14.411 4.46-.513 1.626z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#77C7E0",
    fillRule: "nonzero",
    d: "m70.747 13.972 3.751 4.634-4.57-.35zM59.65 49.322c-1.648 5.228-7.266 8.142-12.544 6.509-5.278-1.634-8.219-7.198-6.57-12.427 1.648-5.228 7.266-8.142 12.544-6.509 5.278 1.634 8.22 7.198 6.57 12.427z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.078 36.442)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "owoqm5wldd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7qano9hi7c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#owoqm5wldd)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.428-.036 10.016 9.92l9.576-4.265c.81-.36 1.596.564-6.164-5.692z",
    fill: "#8BDEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.016 9.921 9.576-4.265s1.587 2.128 1.276 5.032L10.016 9.92v.002z",
    fill: "#228191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.016 9.921 4.363 10.87s7.16-4.375 5.897-10.143l-10.263-.727h.003z",
    fill: "#85F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1.322 11.62 11.34-1.699 3.825 9.532s-10.62 5.41-15.165-7.832z",
    fill: "#5BAEC1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#77C7E0",
    d: "M65.062 44.975 66 41.999l3.004.93-.939 2.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BDEF2",
    d: "m63.942 48.522.938-2.975 3.004.93-.939 2.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#228191",
    d: "m62.774 52.218.939-2.976 3.003.93-.938 2.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85F4FF",
    d: "m61.623 55.865.938-2.976 3.004.93-.939 2.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BAEC1",
    d: "m60.458 59.562.938-2.975 3.004.93-.938 2.975z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.09 59.674c5.33-16.9 4.912-15.176 4.544-15.29l-4.883 15.48 12.974 4.016c.122-.385 1.498.17-12.635-4.203v-.003z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m71.628 55.234.796 1.619 5.003-5.122.985 1.69c6.2-5.983 6.188-5.763-.034.244l-.982-1.685-5.013 5.133-.807-1.642c-5.749 4.5-6.256 4.705.055-.235l-.003-.002z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m73.098 51.461 1.541 5.837 5.942-7.702.59 2.462 2.24-2.372c.16.147.456-.263-2.323 2.68l-.58-2.427-5.936 7.695-1.548-5.867c-8.705 9.375-7.422 7.77.076-.306h-.002z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.988 59.483c-.052-.213-.535-.024 4.454-1.25l.222 1.264 2.186-1.416c-.403 1.279-1.254 1.548 4.579-2.371l-.086 1.174 3.048-1.638c.105.192.438-.064-3.22 1.9l.083-1.138-4.96 3.335.286-.906-2.023 1.31-.234-1.327-4.332 1.065-.003-.002z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.345 52.453c-.34 1.076-1.964.569-1.63-.508.34-1.083 1.964-.569 1.63.508zM78.78 52.72c-.334 1.077-1.965.57-1.631-.507.34-1.083 1.964-.57 1.63.507zM81.886 50.55c-.334 1.078-1.964.57-1.63-.509.339-1.078 1.963-.57 1.63.509z",
    fill: "#2E7682",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.788 54.243c-.34 1.08-1.968.568-1.627-.507.34-1.081 1.967-.568 1.627.507zM72.854 56.11c-.34 1.078-1.964.57-1.63-.509.34-1.078 1.964-.57 1.63.508zM75.97 58.264c-.34 1.083-1.964.57-1.63-.507.333-1.077 1.963-.57 1.63.507zM72.79 59.071c-.34 1.081-1.965.568-1.631-.507.333-1.08 1.964-.568 1.63.507z",
    fill: "#2E7682",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1 58.917c-.34 1.083-1.964.57-1.63-.507.333-1.077 1.964-.57 1.63.507zM79.738 56.6c-.334 1.076-1.964.569-1.63-.508.339-1.083 1.963-.57 1.63.507z",
    fill: "#2E7682",
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.466 23.586c-18.52-5.732-16.742-4.923-16.501-5.687 18.52 5.732 16.742 4.923 16.501 5.687zM94.139 24.62c-18.52-5.732-16.743-4.922-16.501-5.687 18.52 5.733 16.742 4.923 16.5 5.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.747 25.866c-18.52-5.733-16.743-4.923-16.501-5.688 18.52 5.733 16.742 4.923 16.5 5.688zM93.422 26.9c-18.52-5.733-16.742-4.923-16.501-5.688 18.52 5.733 16.742 4.923 16.5 5.688z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.99 28.268c-18.52-5.733-16.743-4.923-16.502-5.688 18.52 5.733 16.743 4.924 16.501 5.688zM92.664 29.3c-18.52-5.733-16.742-4.923-16.5-5.688 18.52 5.733 16.742 4.924 16.5 5.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.27 30.545c-18.52-5.733-16.742-4.923-16.5-5.688 18.52 5.733 16.741 4.924 16.5 5.688zM91.945 31.58c-18.52-5.733-16.742-4.924-16.5-5.688 18.52 5.732 16.742 4.923 16.5 5.687z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.494 33.007c-18.52-5.733-16.743-4.924-16.501-5.688 18.52 5.733 16.742 4.923 16.5 5.688zM91.169 34.04c-18.52-5.732-16.743-4.922-16.501-5.687 18.52 5.733 16.742 4.923 16.5 5.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.774 35.286c-18.52-5.733-16.742-4.923-16.5-5.688 18.52 5.733 16.742 4.923 16.5 5.688zM90.45 36.32c-18.52-5.732-16.743-4.923-16.502-5.687 18.52 5.732 16.743 4.923 16.501 5.687z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.017 37.688c-18.52-5.732-16.742-4.923-16.501-5.687 18.52 5.732 16.742 4.923 16.501 5.687zM89.692 38.72c-18.52-5.732-16.742-4.923-16.5-5.687 18.519 5.732 16.741 4.923 16.5 5.687z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.3 39.965c-18.52-5.732-16.742-4.923-16.5-5.687C91.32 40.01 89.54 39.2 89.3 39.965zM88.973 41c-18.52-5.733-16.742-4.924-16.501-5.688 18.52 5.733 16.742 4.923 16.5 5.688z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.078 61.203.513-1.626 18.436 5.705-.513 1.627zM55.878 67.02l.513-1.626 3.708 1.147-.513 1.627zM60.082 68.322l.513-1.626 18.012 5.574-.513 1.627zM36.52 62.976l.513-1.627 2.739.848-.513 1.627zM35.975 64.707l.513-1.627 7.99 2.473-.514 1.627zM44.502 67.347l.513-1.626 1.865.577-.513 1.627zM46.875 68.08l.513-1.627 8.311 2.572-.513 1.627zM55.53 70.851l.512-1.627 1.643.509-.513 1.626zM57.425 71.438l.513-1.626 1.642.508-.513 1.626zM59.351 71.944l.513-1.627 8.142 2.52-.513 1.626zM68.122 74.657l.513-1.626 8.867 2.744-.513 1.627zM39.728 63.973l.513-1.627 9.558 2.958-.513 1.627zM49.935 67.131l.513-1.626 15.39 4.763-.513 1.626zM65.827 72.05l.513-1.626 11.707 3.623-.513 1.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.458 66.391.513-1.627 18.437 5.706-.513 1.627zM54.258 72.21l.513-1.626 3.709 1.148-.513 1.626zM58.462 73.512l.513-1.626 18.012 5.574-.513 1.627zM34.9 68.169l.513-1.627 2.739.848-.513 1.626zM34.356 69.895l.513-1.627 7.989 2.473-.513 1.626zM42.883 72.533l.513-1.627 1.865.578-.513 1.626zM45.256 73.268l.513-1.627 8.311 2.572-.513 1.627zM53.918 76.05l.513-1.626 1.642.508-.513 1.627zM55.808 76.634l.513-1.626 1.642.508-.513 1.627zM57.734 77.131l.513-1.626 8.142 2.52-.513 1.626zM66.503 79.843l.513-1.627 8.867 2.745-.513 1.626zM38.111 69.161l.513-1.626 9.558 2.958-.513 1.627zM48.316 72.32l.513-1.627 15.39 4.763-.513 1.626zM64.208 77.239l.513-1.627 11.706 3.623-.513 1.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.95 71.691.512-1.627L52.9 75.77l-.513 1.627zM52.751 77.524l.513-1.627 3.708 1.148-.513 1.627zM56.95 78.812l.513-1.626 18.013 5.574-.513 1.627zM33.386 73.468l.513-1.627 2.739.848-.513 1.626zM32.844 75.195l.513-1.627 7.99 2.473-.514 1.626zM41.371 77.83l.513-1.626 1.866.577-.513 1.627zM43.745 78.568l.513-1.627 8.31 2.572-.513 1.627zM52.404 81.348l.513-1.626 1.642.508-.513 1.627zM54.296 81.933l.513-1.627 1.642.508-.513 1.627zM56.223 82.431l.513-1.626 8.142 2.52-.513 1.626zM64.99 85.148l.514-1.627 8.867 2.744-.513 1.627zM36.597 74.46l.513-1.626 9.558 2.958-.513 1.627zM46.804 77.62l.513-1.627 15.39 4.763-.513 1.626zM62.694 82.54l.513-1.627 11.706 3.623-.513 1.627z"
  })))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m25.643 37.442 4.603-2.078 2.35 5.106-4.603 2.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m26.332 38.952 4.603-2.077 1.196 2.6-4.603 2.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m26.742 40.015 4.604-2.077.713 1.55-4.603 2.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m24.593 37.154 1.565-.706 3.063 6.657-1.565.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.655 36.56c1.17.646.497-.344 3.228 5.592l-.165 1.065-3.063-6.658zM24.567 37.05c-.274 1.299-.587.146 2.144 6.082l.92.575-3.064-6.658z",
    fill: "#F6C760"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m25.861 39.311 1.566-.707 1.88 4.088-1.565.707z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m0 49.022 24.36-10.998 2.35 5.107L2.35 54.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m.693 50.526 24.36-10.997 1.196 2.6-24.36 10.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m1.07 51.599 24.36-10.997.713 1.55L1.783 53.15z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.16 49.367 2.014 4.378S-.53 51.847.16 49.367z",
    fill: "#F2AE18"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.514 24.396c-3.878-8.431-13.923-12.154-22.433-8.31-8.514 3.841-12.27 13.792-8.39 22.222 3.878 8.431 13.923 12.154 22.434 8.31 8.511-3.84 12.27-13.791 8.39-22.222zm-29.89 13.491c-3.644-7.922-.115-17.269 7.882-20.876 7.997-3.61 17.433-.113 21.074 7.809 3.644 7.922.115 17.268-7.882 20.876-7.998 3.61-17.433.113-21.077-7.809h.002z",
    fill: "#F6C760",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.84 24.699c-3.708-8.064-13.315-11.624-21.456-7.948-8.14 3.673-11.734 13.19-8.024 21.255 3.711 8.064 13.316 11.623 21.457 7.948 8.14-3.674 11.734-13.191 8.023-21.255zM32.254 37.6c-3.484-7.577-.11-16.514 7.539-19.967 7.648-3.451 16.67-.11 20.156 7.467 3.484 7.577.11 16.514-7.538 19.967-7.649 3.451-16.673.11-20.157-7.467z",
    fill: "#F2AE18",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.645 45.54c-8.098 3.654-17.65.115-21.34-7.906-3.689-8.021-.114-17.484 7.981-21.139 8.098-3.654 17.65-.116 21.34 7.906 3.689 8.021.114 17.484-7.981 21.138z",
    fill: "#ADD3F2",
    fillRule: "nonzero",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.988 15.388)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "2ohmmx7fzf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cvhxa36u8e"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#2ohmmx7fzf)",
    fill: "#ADD3F2",
    fillRule: "nonzero",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-83.74 24.091 11.161)",
    d: "m26.085-22.007 3.496.004.054 53.355-3.496-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-83.74 23.366 19.603)",
    d: "m21.536-13.57 11.144.012.055 53.356-11.145-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-83.74 23.912 20.676)",
    d: "m26.298-12.492 2.71.003.055 53.356-2.71-.003z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-magnifying-glass.0077201be348ffe205739dfa4514c19f.svg";